<template>
  <page-outline 
    :title="listTitle"
    :show-filter="true"
    :show-refresh="true"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinner"
    @toggle-filter="toggleFilters"
    @refresh="reloadData">
    <template slot="secondaryActions">
      <div class="tw-flex tw-gap-2">
        <app-button
          :text="$t('common.email.email_group_add')"
          icon="fa-light fa-plus"
          variant="secondary"
          @click="actionAdd">
        </app-button>
      </div>

      <!-- Section de filtres -->
      <b-collapse v-model="displayFilter" class="mt-3">
        <div class="bg-white border rounded p-3">
          <b-row class="g-3 mb-3">
            <!-- Filtre GroupName -->
            <b-col sm="6" lg="4">
              <div class="bg-light border rounded p-3">
                <label for="filter-group-name" class="form-label font-weight-bold text-muted mb-2">
                  <i class="fa-solid fa-users mr-2"></i>
                  {{ $t('common.email.group_name') }}
                </label>
                <form-write-group-label-input 
                  id="filter-group-name"
                  v-model="GroupName"
                  :inputLabel="$t('common.email.group_name')">
                </form-write-group-label-input>
              </div>
            </b-col>
          </b-row>

          <!-- Boutons d'action -->
          <b-row class="gx-2">
            <b-col cols="6">
              <app-button
                :text="$t('filter.clr_fltr_field')"
                icon="fa-light fa-eraser"
                variant="secondary"
                outline
                :block="true"
                :aria-label="$t('filter.clr_fltr_field')"
                @click="clearFilterFields"
                :disabled="!GroupName || activateSpinner"
              />
            </b-col>
            <b-col cols="6">
              <app-button
                :text="$t('common.srch')"
                icon="fa-light fa-magnifying-glass"
                variant="primary"
                :block="true"
                :aria-label="$t('common.srch') + ' ' + $t('common.email.email_group_list')"
                @click="onRefresh"
                :loading="activateSpinner"
                :loadingText="$t('common.rfrsh')"
              />
            </b-col>
          </b-row>
        </div>
      </b-collapse>
    </template>
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItemsEmailGroup.length > 0"
              :items="listItemsEmailGroup"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              fixed
              hover
              :selectable="listItemsEmailGroup.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="onRowClicked"
              :key="refreshKey">
              <template #cell(GroupName)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdEmailGroup)">
                  <i class="fa-regular fa-pencil"></i>
                </span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdEmailGroup)">
                  <i class="fa-regular fa-trash"></i>
                </span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import AppButton from "@/components/common/AppButton.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "EmailGroupPage",
  components: {
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    "app-button": AppButton,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      GroupName: '',
      listItemsEmailGroup: [],
      listTitle: "",
      refreshKey: false,
      sortBy: 'GroupName'
    }
  },
  created() {
    this.listTitle = this.$i18n.t("common.email.email_group_list")
    this.activateSpinner = true
    this.getEmailGroup()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []

      // fields.push({
      //   key: 'IdEmailGroup',
      //   label: this.$t('common.email.id'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })

      fields.push({
        key: 'GroupName',
        label: this.$t('common.email.group_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, {url: '/email/emailGroup/add/-1' })
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.email.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.firstOn().email.emailGroup.delete(params)
              .then(resp => {
                that.listItemsEmailGroup = that.listItemsEmailGroup.filter(item => item.IdEmailGroup !== id)
                that.$f7.modal({
                  title: that.$t('common.email.email_group_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: '/email/emailGroup/-1' })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.email.email_group_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/email/emailGroup/edit/' + id })
    },
    applyFilter () {
      this.activateSpinner = true
      this.getEmailGroup()
    },
    clearFilterFields () {
      this.GroupName = ''
      // this.applyFilter()
    },
    getEmailGroup () {
      let that = this
      let params = { GroupName: this.GroupName }
      this.$engine.firstOn().email.emailGroup.fetch(params).then((resp) => {
        let emailGroupList = {}

        emailGroupList = resp.data.EmailGroup || []

        that.updateEmailGroup(emailGroupList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getEmailGroup()
    },
    reloadData () {
      this.onRefresh()
    },
    toggleFilters () {
      this.displayFilter = !this.displayFilter
    },
    onRowClicked (item) {
      const emailGroupId = item[0].IdEmailGroup
      loadPage(this, { url: 'email/emailAddress/' + emailGroupId })
    },
    updateEmailGroup (emailGroupList) {
      this.listItemsEmailGroup = emailGroupList
    }
  }
}
</script>

<style scoped>
/* Focus avec couleur DealPrudence */
.btn:focus,
.b-button:focus,
button:focus,
input:focus,
select:focus,
textarea:focus,
a:focus,
[tabindex]:focus {
  box-shadow: 0 0 0 0.25rem rgba(17, 176, 175, 0.25) !important;
}

/* Gutter des rows pour Bootstrap 4 */
.g-3 {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.g-3 > [class*="col-"] {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.gx-2 {
  margin-right: -0.25rem;
  margin-left: -0.25rem;
}

.gx-2 > [class*="col-"] {
  padding-right: 0.25rem;
  padding-left: 0.25rem;
}

/* Style pour le contenu accessible uniquement aux lecteurs d'écran */
.sr-only {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

/* Amélioration du contraste pour les boutons */
.form-label {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.bg-light {
  background-color: #f8f9fa !important;
}
</style>
